var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white border-t border-b border-gray-200 overflow-hidden"},[_c('ul',{staticClass:"divide-y divide-gray-200",attrs:{"role":"list"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }